
const CardWrapper = ({ children }) => (
    <div className="fogged-card" style={{
      padding: '24px',
      borderRadius: '8px',
      boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
      maxWidth: '800px',
      margin: '40px auto',
      textAlign: 'center'
    }}>
      {children}
    </div>
  );

  
  export default CardWrapper;